import type { VolunteerProfile } from '#shared/types/User'

import { CompletenessWeight, useCompleteness } from '@/composables/useCompleteness'
import { isRequired, validate } from 'last-validator'

export function validateVolunteerProfile(volunteerProfile: VolunteerProfile) {
    return validate<VolunteerProfile>(volunteerProfile, {
        interests: [isRequired()],
        cooperation: [isRequired()],
        prefersFieldOfExperience: [isRequired()]
    })
}

export function checkVolunteerProfileComplete(volunteerProfile?: VolunteerProfile) {
    const { evaluate } = useCompleteness()
    
    return evaluate(volunteerProfile, {
        interests: {
            mandatory: true,
            weight: CompletenessWeight.MAX
        },
        cooperation: {
            mandatory: true,
            weight: CompletenessWeight.MAX
        },
        prefersFieldOfExperience: {
            mandatory: true,
            weight: CompletenessWeight.MAX
        },
        helpWho: {
            weight: CompletenessWeight.LOW
        },
        timeCapacity: {
            weight: CompletenessWeight.LOW
        },
        intensityValue: {
            weight: CompletenessWeight.LOW
        }
    })
}
